export default "__VITE_ASSET__CwuQXdDV__";